import { addZero } from "./addZero";
import { formatDate } from "./formatDate";
import { getRelativeDay } from './getRelativeDay';
import { getMonthsLabels } from './getMonthsLabels';

export function formatDateWithMonth(date) {
    const fDate = formatDate(date);
	const dateString = `${fDate.year}-${addZero(fDate.month)}-${addZero(fDate.day)}T${addZero(fDate.hours)}:${addZero(fDate.minutes)}:00`;
	date = new Date(dateString);

	const relativeDay = getRelativeDay(date);
	if (relativeDay) {
		return {
			dayMonth: relativeDay,
			dayMonthShort: relativeDay,
			dayMonthTime: `${relativeDay} - ${fDate.time}`,
			dayMonthYear: relativeDay,
			dayMonthYearTime: `${relativeDay} - ${fDate.time}`
		};
	} else {
        const months = getMonthsLabels();
		const monthNumber = date.getMonth() + 1;
		const monthDesc = months[date.getMonth()];
	
		return {
			dayMonth: `${fDate.day} ${monthDesc}`,
			dayMonthShort: `${addZero(fDate.day)}.${addZero(monthNumber)}`,
			dayMonthTime: `${fDate.day} ${monthDesc} - ${fDate.time}`,
			dayMonthYear: `${fDate.day} ${monthDesc} ${fDate.year}`,
			dayMonthYearTime: `${fDate.day} ${monthDesc} ${fDate.year} - ${fDate.time}`
		};
	}
}
